import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {GroupApi} from './group.api';
import {UserDirectoryApi} from './user-directory.api';
import {QuestionnaireApi} from './questionnaire.api';
import {ComplianceItemApi} from './compliance-item.api';
import {FileApi} from './file.api';
import {VerifyApi} from './verify.api';
import {RegistrationApi} from './registration.api';
import {NoteApi} from './note.api';
import {ComplyMessageApi} from './comply-message.api';
import {TagApi} from './tag.api';
import { Act48Api } from './act48.api';
import { RequestItemApi } from './request-item.api';
import {UserRequestApi} from './user-request.api';
import {VerifyRequestApi} from './request-verify.api';
import { MetricApi } from './metric.api';
import { UserCycleApi } from './user-cycle.api';
import { RosterPreferenceApi } from './roster-preference.api';
import { OnboardingApi } from './onboarding.api';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        OnboardingApi,
        GroupApi,
        UserDirectoryApi,
        QuestionnaireApi,
        ComplianceItemApi,
        FileApi,
        VerifyApi,
        RegistrationApi,
        NoteApi,
        ComplyMessageApi,
        TagApi,
        Act48Api,
        RequestItemApi,
        UserRequestApi,
        VerifyRequestApi,
        MetricApi,
        UserCycleApi,
        RosterPreferenceApi
    ]    
})
export class ApiModule { }